import {
  ClockCircleOutlined,
  MobileOutlined,
  ToolOutlined,
  VideoCameraOutlined,
} from '@ant-design/icons';
import React from 'react';
import styled from 'styled-components';

const Section = styled.section`
  background-color: #f8f9fc;
  padding: 60px 0;
`;

const Title = styled.h2`
  font-size: 2rem;
  font-weight: 700;
  color: #00296b;
`;

const Subtitle = styled.p`
  font-size: 1.1rem;
  color: #555;
`;

const CardBox = styled.div`
  background: #fff;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
  height: 100%;
  transition: 0.3s ease;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 6px 24px rgba(0, 0, 0, 0.1);
  }

  h4 {
    font-size: 1.125rem;
    font-weight: 600;
    color: #003366;
    margin-top: 16px;
  }

  p {
    font-size: 0.95rem;
    color: #333;
  }

  .icon {
    font-size: 28px;
    color: #1890ff;
  }
`;

export default function TentangProclass() {
  return (
    <Section>
      <div className="container px-3 px-md-4 px-lg-5">
        <Title className="mb-3">Why ProClass Is Designed for Learners Like You</Title>
        <Subtitle className="mb-2">Belajar itu gak harus ribet.</Subtitle>
        <p className="mb-3">
          MyEduSolve ProClass adalah solusi belajar mandiri berbasis video dari MyEduSolve — tanpa
          tekanan, dengan durasi akses yang cukup fleksibel supaya kamu bisa fokus belajar.
        </p>
        <p className="mb-5">
          Cukup pilih kelas yang kamu butuh, tonton videonya, dan praktikkan langsung. Setelah
          menyelesaikan kelas, kamu akan mendapatkan sertifikat tanda penyelesaian sebagai bukti
          bahwa kamu sudah menguasai materi.
        </p>

        <h3 className="mb-4 font-weight-bold">Keunggulan MyEduSolve ProClass</h3>
        <div className="row">
          <div className="col-md-6 col-lg-3 mb-4">
            <CardBox>
              <VideoCameraOutlined className="icon" />
              <h4>Video Singkat & Praktis</h4>
              <p>Fokus ke skill yang bisa langsung kamu pakai</p>
            </CardBox>
          </div>
          <div className="col-md-6 col-lg-3 mb-4">
            <CardBox>
              <ClockCircleOutlined className="icon" />
              <h4>Akses Fleksibel</h4>
              <p>Belajar dengan durasi yang memadai — kapan saja, secepat atau sesantai kamu mau</p>
            </CardBox>
          </div>
          <div className="col-md-6 col-lg-3 mb-4">
            <CardBox>
              <MobileOutlined className="icon" />
              <h4>Ramah Mobile & Laptop</h4>
              <p>Nonton lewat HP, tablet, atau laptop, belajar jadi makin fleksibel</p>
            </CardBox>
          </div>
          <div className="col-md-6 col-lg-3 mb-4">
            <CardBox>
              <ToolOutlined className="icon" />
              <h4>Skill Beneran Terpakai</h4>
              <p>Gak cuma teori — kamu bisa langsung praktik dan pakai di dunia nyata</p>
            </CardBox>
          </div>
        </div>
      </div>
    </Section>
  );
}
